// extracted by mini-css-extract-plugin
export default {"background_clear":"providerImagesOrButtonForUpload_background_clear__X14+B","background_upload":"providerImagesOrButtonForUpload_background_upload__5DZcD"};